import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Category colors mapping
export const CATEGORY_COLORS = {
  physical: "#E76F51",
  emotional: "#2A9D8F",
  family: "#E9C46A",
  social: "#F4A261",
  financial: "#264653",
  career: "#2C3E50",
  intellectual: "#8AB17D",
  spiritual: "#B5838D",
};

// Heat map color based on score (1-10)
export function getHeatColor(score) {
  if (!score || score === 0) return "bg-muted";
  if (score <= 2) return "bg-red-200";
  if (score <= 4) return "bg-orange-200";
  if (score <= 6) return "bg-yellow-200";
  if (score <= 8) return "bg-green-200";
  return "bg-green-400";
}

// Format date
export function formatDate(dateString) {
  if (!dateString) return "";
  return new Date(dateString).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

// Local storage helpers
export function saveToLocal(key, data) {
  try {
    localStorage.setItem(key, JSON.stringify(data));
  } catch (e) {
    console.error("Error saving to localStorage:", e);
  }
}

export function loadFromLocal(key) {
  try {
    const data = localStorage.getItem(key);
    return data ? JSON.parse(data) : null;
  } catch (e) {
    console.error("Error loading from localStorage:", e);
    return null;
  }
}

export function clearLocal(key) {
  try {
    localStorage.removeItem(key);
  } catch (e) {
    console.error("Error clearing localStorage:", e);
  }
}
